import { Injectable } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { PlatformLocation } from '@angular/common';
import { environment } from "environments/environment";
import { BehaviorSubject } from "rxjs/Rx";

@Injectable()
export class MemberService {

  public serviceStackUrl;
  public foundMembers = new BehaviorSubject<any>({});

  constructor(private _restService: RestService, platformLocation: PlatformLocation) { 
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
  }

  AddEditMember(Member: any): Promise<any> {
    console.log("save members", Member)
    let url = this.serviceStackUrl + "Member-AddEditMember";
    return this._restService.post(url, {Member});
  }

  formatPhone(string) {
    console.log(string.length);
    if (string.length > 0) {
      var phoneRe = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
      var digits = string.replace(/\D/g, "");
      if (phoneRe.test(digits)) {
        let numbers = string.replace(/\D/g, ''),
        char = { 0: '(', 3: ') ', 6: '-' };
        string = '';
        for (let i = 0; i < numbers.length; i++) {
          string += (char[i] || '') + numbers[i];
        }
        return string;
      } else {
        return false;
      }
    } else {
      return string;
    }
  } 
  
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/member/member.service.ts